import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import { COLORS } from '../../design-system/settings/variables/Colors';
import { SPACERS } from '../../design-system/settings/variables/Spacers';
import { FeedbackDashboardAppliedFiltersProps } from './FeedbackDashboardAppliedFilters';
import SearchFilter from './FiltersDropdown/SearchFilter';
import FiltersBar from './FiltersDropdown/FiltersBar';
import { ApplyFilters } from './FiltersDropdown/ShowFilter';

interface FilterPillProps {
  filterType: string;
  filters: FeedbackFilter[];
  onClick: (key: string) => unknown;
}

export const FilterPill: React.FC<FilterPillProps> = ({
  filters,
  filterType,
  onClick,
}): JSX.Element | null => {
  if (filters.length === 0) return null;
  return (
    <>
      {filters.map(f => (
        <div className="filter_pill" key={f.name}>
          <span className="filter_pill__name">
            <strong>{filterType}: </strong>
            {f.name}
          </span>
          <FontAwesomeIcon
            icon={faTimes}
            onClick={() => onClick(f.value || f.name)}
          />
        </div>
      ))}
    </>
  );
};

const StyledDiv = styled.div`
  .search_bar__wrapper {
    background-color: ${COLORS.greyBase};
    padding: ${SPACERS.large};
  }

  .filter_bar__wrapper {
    background-color: ${COLORS.greyDark};
    padding: ${SPACERS.large};
    color: ${COLORS.whiteBase};
    display: flex;
    flex-wrap: wrap;
    & .heading-label {
      color: ${COLORS.whiteBase};
    }
    .filter_pill__name {
      color: ${COLORS.blackBase};
    }

    > div:nth-child(1) {
      width: 100%;
    }
  }

  .filter_selectors {
    flex: 3;
    width: 70%;
    padding-right: ${SPACERS.large};
    margin-bottom: ${SPACERS.large};
    border-right: 1px solid ${COLORS.greyLight};
  }
  .filter_input__wrapper {
    // display: flex;
    // flex-wrap: wrap;
    // flex-grow: 1;
    // width: 80%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: ${SPACERS.medium};
  }

  .saved_filters__wrapper {
    display: flex;
    flex-direction: column;
    gap: ${SPACERS.small};
    flex: 1;
    margin-left: auto;
    padding-left: ${SPACERS.large};
    .save-button {
      color: ${COLORS.blackBase};
      &[disabled] {
        cursor: default;
      }
    }
  }

  .applied_sort__wrapper {
    width: 100%;
    display: flex;
    .clear-filters {
      display: flex;
      align-items: center;
      padding-left: 24px;
      padding-right: 24px;
      height: 48px;
      color: ${COLORS.whiteBase};
      border: 1px solid ${COLORS.whiteBase};
      border-radius: 4px;
      background-color: inherit;
      cursor: pointer;
      margin-right: 32px;
      margin-top: 26px;
      &[disabled] {
        visibility: hidden;
      }
    }
  }

  .applied_filters__wrapper {
    // width: 60%;
    padding-right: ${SPACERS.large};
    flex: 3;
    // display: flex;
    .filter_pills__wrapper {
      display: flex;
      flex-wrap: wrap;
      gap: ${SPACERS.tiny};
      margin-bottom: ${SPACERS.small};
    }
    .filter_pill {
      background-color: ${COLORS.whiteBase};
      color: $black-base;
      line-height: 1;
      border-radius: 50px;
      display: flex;
      flex-shrink: 0;
      align-items: center;
      padding: ${SPACERS.tiny} ${SPACERS.small};
      gap: ${SPACERS.tiny};
      svg {
        cursor: pointer;
        path {
          fill: inherit;
        }
      }
    }
  }
  .sort__wrapper {
    // width: 40%;
    flex: 2;
  }
`;

export interface FeedbackFilter {
  name: string;
  value?: string;
  count?: number | string;
  selected?: boolean;
}

export interface FeedbackFilters {
  [id: string]: FeedbackFilter;
}

interface FeedbackDashboardFilterBarProps
  extends FeedbackDashboardAppliedFiltersProps {
  handleClearAllFilters: () => unknown;
  handleApplyAllFilters: (filters: ApplyFilters) => unknown;
  handleSearchTerm: (s: string) => unknown;
  type: 'donor' | 'TI staff';
  anyFiltersApplied: boolean;
  className?: string;
}

const FeedbackDashboardFilterBar: React.FC<FeedbackDashboardFilterBarProps> = ({
  type,
  donorNames,
  relationships,
  portfolioNames,
  cycles,
  status,
  trueImpactStaff,
  dueDates,
  charityNavigator,
  years,
  sortBy,
  className,
  anyFiltersApplied,
  handleClearAllFilters,
  handleSearchTerm,
  handleApplyAllFilters,
}) => {
  return (
    <StyledDiv className={className}>
      <SearchFilter onChange={handleSearchTerm} />
      <FiltersBar
        handleClearAllFilters={handleClearAllFilters}
        handleApplyAllFilters={handleApplyAllFilters}
        type={type}
        anyFiltersApplied={anyFiltersApplied}
        donorNames={donorNames}
        relationships={relationships}
        portfolioNames={portfolioNames}
        cycles={cycles}
        status={status}
        trueImpactStaff={trueImpactStaff}
        dueDates={dueDates}
        charityNavigator={charityNavigator}
        years={years}
        sortBy={sortBy}
      />
    </StyledDiv>
  );
};

export default FeedbackDashboardFilterBar;
